import { BookOpenIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface TrustStat {
  icon: LucideIcon;
  value: string;
  label: string;
}

export const trustStats: TrustStat[] = [
  { icon: BookOpenIcon, value: '6 + 5', label: 'Tomos y bonos incluidos' },
  { icon: DownloadIcon, value: '11', label: 'PDF descargables' },
  { icon: Building2Icon, value: 'Más de 1.000', label: 'Clubes y Colegios' },
  { icon: ClockIcon, value: '414', label: 'Páginas de contenido' }
];

export interface TrustBadge {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const trustBadges: TrustBadge[] = [
  {
    icon: GraduationCapIcon,
    title: 'Voleibol Base Real',
    text: 'Diseñado para entrenadores de voleibol que trabajan con equipos de formación y necesitan soluciones aplicables a sus entrenamientos reales. Grupos de distintos niveles, espacios reducidos, poco tiempo para planificar y jugadores que necesitan progresar.'
  },
  {
    icon: LayersIcon,
    title: 'Adaptación por nivel de juego',
    text: 'Tres niveles de entrada para elegir según lo que tu equipo puede resolver: iniciación, continuidad y juego organizado. Las fichas incluyen opciones para facilitar o aumentar la dificultad.'
  },
  {
    icon: SmartphoneIcon,
    title: 'Multidispositivo',
    text: 'Tablet, móvil, PC o para imprimir — consúltalo durante el entrenamiento sin que nadie lo note. Acceso desde cualquier lugar.'
  }
];
